// dome

export default [
  // dome authentication
  {
    path: '/tdpt',
    name: 'Tdpt',
    component: () => import(/* webpackChunkName: "Signin" */ '@/components/third-part'),
    children: [
      {
        path: 'signin',
        name: 'Signin',
        component: () => import(/* webpackChunkName: "Signin" */ '@/components/third-part/login-page')
      },
      {
        path: 'authentication',
        name: 'Authentication',
        component: () => import(/* webpackChunkName: "Signin" */ '@/components/third-part/authentication')
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/thirdpart.js